export default [
  {
    title: 'Firmalar',
    route: 'firmalar',
    icon: 'fad fa-building',
    children: [],
  },
];
